var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-row align-items-center justify-content-center py-5"
    },
    [
      _c("stamp", {
        staticClass: "animate animate--long animate--rotate primary-text"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }